




































import Vue from 'vue';
import Validation from '../../mixins/validation';
import FieldNativeSelect from '@/components/dumb/FieldNativeSelect.vue';
import IconCarat from '@/components/dumb/IconCarat.vue';
export default Vue.extend({
	name: 'FieldDropdown', 
	props: {
		name: String, 
		label: String, 
		value: String, 
		rules: Array, 
		options: Array
	}, 
	components: {
		FieldNativeSelect, 
		IconCarat
	},
	data(): any {
		return {
			isTouchEnabled: true, 
			field: {
				value: null, 
				isValid: false
			}
		};
	}, 
	methods: {
		handleFieldBlur(): void {
			this.handleFieldInput();
			this.$emit('blur', this.field.isValid);
		},
		handleFieldFocus(): void {
			this.$emit('focus');
		}, 
		handleFieldInput(): void {
			Validation.setFieldValid(this.field, this.rules)
			this.$emit('input', this.field.isValid ? this.field.value : '');
		}, 
		searchKeydownHandler(e: KeyboardEvent): any {
			if (e.key == '`'){
				e.preventDefault();
				return false;
			}
			return true;
		},
		documentKeydownHandler(e: KeyboardEvent): any {
			if ((e.target as HTMLElement).parentElement?.classList.contains('v-select__slot')){
				return this.searchKeydownHandler(e);
			}
		}
	}, 
	created(): void {
        try {  
          document.createEvent("TouchEvent");  
          this.isTouchEnabled = true;
        } 
        catch(e){  
          this.isTouchEnabled = false;
        }
	},
	mounted(): void {
		if (this.value){
			this.field.value = this.value;
			this.field.isValid = true;
		}

		document.addEventListener('keydown', this.documentKeydownHandler);
	},
	beforeDestroy(): void {
		document.removeEventListener('keydown', this.documentKeydownHandler);

    }
});
